<template>
    <div class="tw-space-y-3">
        <div v-for="m in messages" :key="m.id"
            class="tw-flex" :class="isMine(m) ? 'tw-justify-end' : 'tw-justify-start'">
            <div class="tw-max-w-[80%]">
                <div class="tw-rounded-2xl tw-px-4 tw-py-2.5 tw-text-sm tw-border tw-border-solid tw-whitespace-pre-wrap"
                    :class="isMine(m)
                        ? 'tw-bg-primary-500 tw-text-white tw-border-primary-600 tw-rounded-br-sm'
                        : 'tw-bg-gray-50 tw-text-gray-800 tw-border-gray-200 tw-rounded-bl-sm'">
                    {{ m.body }}
                </div>
                <div class="tw-mt-1 tw-text-[11px] tw-text-gray-400" :class="isMine(m) ? 'tw-text-end' : 'tw-text-start'">
                    <span class="tw-font-medium">{{ m.is_admin ? $t('portal.tickets.support') : (m.author_name || $t('portal.tickets.you')) }}</span>
                    · {{ fmt.datetime(m.created_at) }}
                </div>
            </div>
        </div>
        <p v-if="!messages.length" class="tw-text-center tw-text-gray-400 tw-py-6">{{ $t('portal.tickets.no-messages') }}</p>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useFormat } from '@/composables/useFormat';

const props = defineProps({
    messages: { type: Array, default: () => [] },
    // Whose messages align to the right: true = admin view, false = client view.
    mineIsAdmin: { type: Boolean, default: false },
});

const fmt = useFormat();

const isMine = (m) => !!m.is_admin === props.mineIsAdmin;
</script>
